<template>
    <fieldset class="multi-write">
        <legend>
            {{ label }}
            <span v-if="!!required" class="required">*</span>
        </legend>
        <div v-for="(_, index) in getValues"
             :key="index"
        >
            <input :placeholder="placeholder"
                   :class="inputClasses"
                   :name="name"
                   :id="name"
                   :value="getInputValue(index)"
                   type="search"
                   @input="onInputEvent($event, index)"
            />
            <button v-if="index === getInputCount && getInputCount + 1 < repeatTimes"
                    class="multi-write-primary"
                    @click="onMultiWriteEvent"
            >
                <i class="uil uil-plus"></i>
            </button>
            <button v-if="getValues.length > 1"
                    class="multi-write-danger"
                    @click="onMultiWriteRemove(index)"
            >
                <i class="uil uil-times"></i>
            </button>
        </div>
        <form-error v-if="errors"
                    :field="name"
                    :errors="errors"
        />
    </fieldset>
</template>

<script>
import FormGroup from '../Holders/FormGroup';
import { clone } from '../../../../Src/Utils/Json';
import FormError from '../Errors/FormError';

export default {
    name: 'MultiWrite',
    emits: [
        'update',
    ],
    components: {
        FormGroup,
        FormError,
    },
    props: {
        value: {
            type: Array,
            default: () => ([])
        },
        repeatTimes: {
            type: Number,
            default: 3
        },
        label: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        inputClasses: {
            type: String,
            default: null
        },
        errors: {
            default: null
        },
        required: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            inputsCount: 1,
        };
    },
    computed: {
        getInputCount() {
            return this.getValues.length - 1;
        },
        getValues() {
            let values = [];

            if (!!this.value) {
                values = this.value.length > this.repeatTimes
                    ? this.value.slice(0, this.repeatTimes)
                    : this.value;
            }

            const finalValues = !!values.length
                ? values
                : [
                    {
                        index: 1,
                        value: null
                    }
                ];

            return this.sortValues(finalValues);
        },
    },
    methods: {
        onMultiWriteEvent() {
            const lastIndex = this.getValues[this.getValues.length - 1];

            const values = [
                ...this.getValues,
                {
                    index: lastIndex.index + 1,
                    value: null
                }
            ];

            this.onUpdateValueEvent(values);
        },
        getInputValue(index) {
            if (!this.value) {
                return null;
            }

            const value = this.value.find(item => item.index === index);

            if (!value) {
                return null;
            }

            return value.value;
        },
        onInputEvent(event, index) {
            const inputValue = event.target.value;
            let componentValue = clone(this.value);

            if (!componentValue) {
                componentValue = [
                    {
                        index,
                        value: inputValue
                    }
                ];
            } else {
                const findValueIndex = componentValue.findIndex(item => item.index === index);

                if (findValueIndex === -1) {
                    componentValue = [
                        ...componentValue,
                        {
                            index,
                            value: inputValue
                        }
                    ];
                } else {
                    componentValue[findValueIndex].value = inputValue;
                }
            }

            this.onUpdateValueEvent(
                this.sortValues(componentValue)
            );
        },
        onMultiWriteRemove(index) {
            const values = this.getValues.filter(item => item.index !== index);

            this.onUpdateValueEvent(values);
        },
        onUpdateValueEvent(value) {
            const values = value.map((item, index) => {
                    return {
                        ...item,
                        index
                    };
                });

            this.$emit('update', this.name, values);
        },
        sortValues(values) {
            return values.sort((a, b) => a.index + b.index);
        },
    },
}
</script>